// extracted by mini-css-extract-plugin
export default {"body":"style_body__X0YpS","container":"style_container__ekKt3","action":"style_action__2PbeF"};